import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { BodyOverlay } from '../BodyOverlay/BodyOverlay';

@Component
export class DrawerContainer extends ThemeComponent {
    @Ref({ required: false }) drawerContent!: HTMLElement;

    @Prop() useOverlay!: boolean;

    private focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    private previousFocus: Element = document.body;
    private bodyOverlay: BodyOverlay|null = document.querySelector('.body-overlay');

    /** Initialise component */
    init() {
        document.addEventListener('bodyOverlayLoaded', () => this.bodyOverlayLoaded());
        this.setAttribute('aria-hidden', 'true');
    }

    bodyOverlayLoaded() {
        this.bodyOverlay = document.querySelector('.body-overlay') as BodyOverlay;

        if (this.bodyOverlay) {
            this.$subscribe(this.bodyOverlay.onCloseChange, () => {
                this.close();
            });
        }
    }

    /** Handle focus lock */
    handleFocusLock() {
        const firstFocusableElement = this.querySelectorAll(this.focusableElements)[0] as HTMLElement;
        const focusableContent = this.querySelectorAll(this.focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1] as HTMLElement;

        document.addEventListener('keydown', (e) => {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    e.preventDefault();
                    lastFocusableElement.focus(); // add focus for the last focusable element
                }
            } else { // if tab key is pressed
                if (firstFocusableElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }

                if (document.activeElement === lastFocusableElement) {
                    e.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        });

        setTimeout(()=> {
            // firstFocusableElement.focus();
        }, 300);
    }

    /** Drawer open */
    public open() {

        this.bodyOverlay = document.querySelector('.body-overlay');

        if (document.activeElement) {
            this.previousFocus = document.activeElement;
        }

        if (this.useOverlay) {
            this.bodyOverlay?.openOverlay();
        }
        document.body.classList.add('prevent-scroll');
        document.querySelector('.header')?.classList.add('cover-header');
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.handleFocusLock();
    }

    /** Drawer close */
    public close() {
        const previous = this.previousFocus as HTMLElement;

        if (this.useOverlay) {
            this.bodyOverlay?.closeOverlay();
        }
        document.body.classList.remove('prevent-scroll');
        document.querySelector('.header')?.classList.remove('cover-header');
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        previous.focus();
    }
}
